import '../../common/js/common';
import './frame-netbank.scss';
import Vue from 'vue';
import header from '../header/header-netbank/header-netbank';
import footer from '../footer/footer-portal/footer-portal';
import i18n from '../../common/js/lang/i18n';

/* eslint-disable no-new*/
new Vue({
	...header,
	i18n
});
new Vue({
	...footer,
	i18n
});
/* eslint-enable*/
